import { render, staticRenderFns } from "./ProbnoPitanje.vue?vue&type=template&id=77720161&scoped=true&"
import script from "./ProbnoPitanje.vue?vue&type=script&lang=js&"
export * from "./ProbnoPitanje.vue?vue&type=script&lang=js&"
import style0 from "./ProbnoPitanje.vue?vue&type=style&index=0&id=77720161&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77720161",
  null
  
)

export default component.exports